import { BaseLayout } from '@/components/layouts'
import { Head } from '@/components/layouts'
import { useRouter } from '@/core'
import { useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { Action, State } from '.'
import { EmailAddressSettingForm } from './EmailAddressInputForm'
import { EmailAddressSettingFormSNS } from './EmailAddressInputFormSNS'

export const EmailAddressInputTemplate: Template<
  State,
  Pick<Action, 'sendVerificationMail'>
> = ({ state, sendVerificationMail }) => {
  const { t } = useTranslation('emailAddressSettings')
  const { routerNames, routerPages } = useRouter()

  return (
    <>
      <BaseLayout
        margin
        header={{
          title: t('title'),
          back: true,
          defaultBackPage: routerPages.AccountSetting,
        }}
      >
        <Head title={routerNames.EmailSetting} />
        <EmailAddressSettingForm
          state={state}
          onSubmit={sendVerificationMail}
        />
      </BaseLayout>
    </>
  )
}

export const EmailAddressInputSocialTemplate: Template<
  State,
  Pick<Action, 'sendVerificationMailSocial'>
> = ({ state, sendVerificationMailSocial }) => {
  const { t } = useTranslation('emailAddressSettings')
  const { routerNames, routerPages } = useRouter()

  return (
    <>
      <BaseLayout
        margin
        header={{
          title: t('title'),
          back: true,
          defaultBackPage: routerPages.AccountSetting,
        }}
      >
        <Head title={routerNames.EmailSetting} />
        <EmailAddressSettingFormSNS
          state={state}
          onSubmit={sendVerificationMailSocial}
        />
      </BaseLayout>
    </>
  )
}
